import { EditCompanyPanelWebComponent } from './component/EditCompanyPanelWebComponent';
import { WEB_COMPONENT_EDIT_COMPANY_PANEL } from '../../../webcomponents.constants';

export { EditCompanyPanelWebComponent };

window.customElements.define(WEB_COMPONENT_EDIT_COMPANY_PANEL, EditCompanyPanelWebComponent);
